import type { SVGProps } from 'react';
const SvgIconDisclosureLeftSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.662 12.394a.75.75 0 0 0 .074-1.058L7.33 8l2.406-3.336a.75.75 0 0 0-1.132-.985l-3.33 3.829a.75.75 0 0 0 0 .984l3.33 3.829a.75.75 0 0 0 1.058.073"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureLeftSmall;
